import { render, staticRenderFns } from "./disciplineInfo.vue?vue&type=template&id=20e27b41&scoped=true&style=overflow-x%3Ahidden&"
import script from "./disciplineInfo.vue?vue&type=script&lang=js&"
export * from "./disciplineInfo.vue?vue&type=script&lang=js&"
import style0 from "./disciplineInfo.vue?vue&type=style&index=0&id=20e27b41&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e27b41",
  null
  
)

export default component.exports